import dayjs from 'dayjs';

import type { SocMonthlySummaryDialogFormValues } from './SocMonthlySummaryDialog.types';

export const BLANK_REPORT_INSIGHTS: SocMonthlySummaryDialogFormValues = {
  id: null,
  body_1: '',
  body_2: '',
  reportInsightsMonth: dayjs(),
  valid_for_month: '',
  published: false
};

export default BLANK_REPORT_INSIGHTS;
